// Color functions
// From: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb

export function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}

export function darker(colorHex, amount=0.10) {
  const { r, g, b } = hexToRgb(colorHex)
  return rgbToHex(
    Math.max(Math.min(Math.round(r - r * amount), 255), 0),
    Math.max(Math.min(Math.round(g - g * amount), 255), 0),
    Math.max(Math.min(Math.round(b - b * amount), 255), 0)
  )
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/helpers/color.js